import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getScheduledProducts } from '../../../../api/action/products';
import { register, signin } from '../../../../api/action/user';
import { KRUMAGO } from '../../../s3-assets/Krumago';
import { useSelector } from 'react-redux';
import { Snackbar } from '../../../../components/ui/Feedback';

const Button = ({ children, className = '', type = 'button', ...props }) => (
    <button
        type={type}
        className={`rounded-md bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-slate-700 ${className}`}
        {...props}
    >
        {children}
    </button>
);

const Modal = ({ children, open }) => (open ? children : null);

const AdmissionForm = () => {
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const dispatch = useDispatch();
    const [validProducts, setValidProducts] = useState([]);

    const [openModal, setOpenModal] = useState(false);
    const handleModalClose = () => {
        setOpenModal(false);
    };

    const handleModalOpen = () => {
        setOpenModal(true);
    };
    const [companyId, setCompanyId] = useState(null);
    const [applicant, setApplicant] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        password: '',
        confirmPassword: '',
        gender: '',
        status: 'EMAIL_VERIFIED',
        addressList: [
            {
                streetName1: '',
                streetName2: '',
                city: '',
                state: '',
                zipcode: '',
                country: '',
                type: 'HOME',
            },
        ],
        educationDetails: [
            {
                schoolName: '',
                degree: '',
                currentlyStudying: false,
                startDate: '',
                endDate: '',
            },
        ],
        dynamicAttributes: [
            { name: 'Nationality', value: '' },
            { name: 'Community', value: '' },
            { name: 'Language', value: '' },
            { name: 'Stream', value: '' },
            { name: 'Registration Class', value: '' },
            { name: 'How did you know about Velammal', value: '' },
        ],
        company: {
            primaryId: null,
            code: null,
            domain: { type: null },
        },
        userRole: 'APPLICANT',
        contactPerson: {
            firstName: '',
            lastName: '',
            email: '',
            phoneNumber: '',
            dynamicAttributes: [
                { name: 'Relationship', value: "Mother" }
            ]
        },
        parentDetails: [
            {
                firstName: '',
                lastName: '',
                email: '',
                phoneNumber: '',
                occupation: '',
                annualIncome: '',
                dynamicAttributes: [{ name: 'Relationship', value: 'Mother' }],
            },
            {
                firstName: '',
                lastName: '',
                email: '',
                phoneNumber: '',
                occupation: '',
                annualIncome: '',
                dynamicAttributes: [{ name: 'Relationship', value: 'Father' }],
            },
        ],
    });

    useEffect(() => {
        const storedCompanyId = localStorage.getItem('CompanyId');
        const storedDomainType = localStorage.getItem('domainType'); // Retrieve domainType from localStorage

        if (storedCompanyId) {
            setCompanyId(storedCompanyId);
            setApplicant(prevState => ({
                ...prevState,
                company: {
                    ...prevState.company,
                    primaryId: storedCompanyId,
                    code: storedCompanyId,
                },
                domain: { type: storedDomainType } // Add domain type to the applicant state
            }));
        }
    }, []);



    const handleChange = (field, value) => {
        setApplicant((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    const handleNestedChange = (parentKey, index, fieldKey, newValue) => {
        if (Array.isArray(applicant[parentKey])) {
            const updatedArray = [...applicant[parentKey]];
            updatedArray[index] = {
                ...updatedArray[index],
                [fieldKey]: newValue,
            };
            setApplicant({
                ...applicant,
                [parentKey]: updatedArray,
            });
        } else {
            setApplicant({
                ...applicant,
                [parentKey]: {
                    ...applicant[parentKey],
                    [fieldKey]: newValue,
                },
            });
        }
    };
    useEffect(() => {
        const fetchValidProducts = async () => {
            try {
                const productsResponse = await getScheduledProducts(companyId)(dispatch);

                if (productsResponse && Array.isArray(productsResponse)) {
                    // Set the entire response, not just the product list
                    setValidProducts(productsResponse);
                } else {
                    setValidProducts([]);
                }
            } catch {
                setValidProducts([]);
            }
        };

        fetchValidProducts();
    }, [companyId, dispatch]);



    const validateEmail = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    };

    const validatePhoneNumber = (phoneNumber) => {
        const phonePattern = /^\d{10}$/;
        return phonePattern.test(phoneNumber);
    };
    const companyInfo = useSelector((state) => state.companyReducer.company);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!applicant.firstName || !applicant.lastName || !applicant.email || !applicant.phoneNumber || !applicant.password || !applicant.confirmPassword) {
            setSnackbarMessage('All fields are required.');
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
            return;
        }

        if (!validateEmail(applicant.email)) {
            setSnackbarMessage('Invalid email format.');
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
            return;
        }

        if (!validatePhoneNumber(applicant.phoneNumber)) {
            setSnackbarMessage('Phone number must be 10 digits.');
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
            return;
        }

        if (applicant.password !== applicant.confirmPassword) {
            setSnackbarMessage('Passwords do not match.');
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
            return;
        }

        try {
            const response = await dispatch(register(applicant));

            if (response) {
                const { userRole, email, primaryId, message } = response;
                const backendErrorMessage = message || "An error occurred. Please try again later.";

                if (userRole === "APPLICANT") {
                    localStorage.setItem('email', email);
                    localStorage.setItem('userId', primaryId);

                    // Delay before calling signin
                    setTimeout(async () => {
                        const loginResponse = await dispatch(signin({ email, password: applicant.password }));

                        if (loginResponse.jwtResponse && loginResponse.jwtResponse.jwtToken) {
                            localStorage.setItem("token", loginResponse.jwtResponse.jwtToken);

                            // localStorage.setItem("selectedCompanyDomain", companyDomainType);
                            // localStorage.setItem("selectedCompanyprimaryId", companyprimaryId);

                            const userRole = loginResponse.userDetails.userRole;
                            localStorage.setItem("userRole", userRole);

                            if (userRole === "APPLICANT") {
                                const parsedCompanyInfo = JSON.parse(companyInfo);
                                if (parsedCompanyInfo._id !== loginResponse.company._id) {
                                    return;
                                }
                                window.location.href = "/application-additional-info";
                            }
                        } else {
                            setSnackbarMessage("Login failed after registration. Please try again.");
                            setSnackbarSeverity("error");
                            setOpenSnackbar(true);
                        }
                    }, 1000);
                } else if (backendErrorMessage.includes('A user with email')) {
                    setSnackbarMessage('Email already taken. Please use a different email.');
                    setSnackbarSeverity('error');
                    setOpenSnackbar(true);
                }
            } else {
                const backendErrorMessage = response?.message || "An error occurred. Please try again later.";
                if (backendErrorMessage.includes('A user with email')) {
                    setSnackbarMessage('Email already taken. Please use a different email.');
                    setSnackbarSeverity('error');
                    setOpenSnackbar(true);
                } else {
                    setSnackbarMessage(backendErrorMessage);
                    setSnackbarSeverity('error');
                    setOpenSnackbar(true);
                }
            }
        } catch (err) {
            const errorMessage = err?.response?.data?.message || "An error occurred. Please try again later.";
            setSnackbarMessage(errorMessage);
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
        } finally {
            setOpenSnackbar(true);
        }
    };


    return (
        <div
            className="min-h-screen flex items-center justify-center bg-cover bg-center mb-6"
            style={{ backgroundImage: `url(${KRUMAGO.IMAGES.ADMISSION})` }}

        >            <div className="max-w-5xl w-full">
                <br /> <br />

                <div className="bg-white bg-opacity-70 p-6 rounded-lg shadow-md max-w-5xl w-full">

                    <div className="bg-white bg-opacity-70 p-6 rounded-lg shadow-md max-w-5xl w-full">
                        <div className="bg-blue-700 p-2 rounded shadow-md max-w-xl mx-auto">
                            <h1 className="text-2xl font-bold text-center text-white mb-3">ONLINE APPLICATION REGISTRATION</h1>
                        </div>
                        <br />
                        <form onSubmit={handleSubmit}>
                            <section className="space-y-6 bg-gray-100 p-6 rounded-lg shadow-md">
                                <h2 className="text-lg font-semibold text-[#824296] text-center">Personal Information</h2>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                    {/* First Name */}
                                    <div className="relative flex flex-col mb-6">
                                        <label htmlFor="firstName" className="text-gray-600 text-sm mb-2">First Name *</label>
                                        <input type="text" id="firstName" value={applicant.firstName} required onChange={(e) => handleChange('firstName', e.target.value)} className="w-full p-3 border rounded-md" />
                                    </div>

                                    {/* Last Name */}
                                    <div className="relative flex flex-col mb-6">
                                        <label htmlFor="lastName" className="text-gray-600 text-sm mb-2">Last Name *</label>
                                        <input type="text" id="lastName" value={applicant.lastName} required onChange={(e) => handleChange('lastName', e.target.value)} className="w-full p-3 border rounded-md" />
                                    </div>

                                    {/* Email */}
                                    <div className="relative flex flex-col mb-6">
                                        <label htmlFor="email" className="text-gray-600 text-sm mb-2">Email *</label>
                                        <input type="email" id="email" value={applicant.email} required onChange={(e) => handleChange('email', e.target.value)} className="w-full p-3 border rounded-md" />
                                    </div>

                                    {/* Phone Number */}
                                    <div className="relative flex flex-col mb-6">
                                        <label htmlFor="phoneNumber" className="text-gray-600 text-sm mb-2">Phone Number *</label>
                                        <input type="text" id="phoneNumber" value={applicant.phoneNumber} required onChange={(e) => handleChange('phoneNumber', e.target.value)} className="w-full p-3 border rounded-md" />
                                    </div>

                                    {/* Password */}
                                    <div className="relative flex flex-col mb-6">
                                        <label htmlFor="password" className="text-gray-600 text-sm mb-2">Password *</label>
                                        <input type="password" id="password" required value={applicant.password} onChange={(e) => handleChange('password', e.target.value)} className="w-full p-3 border rounded-md" />
                                    </div>

                                    {/* Confirm Password */}
                                    <div className="relative flex flex-col mb-6">
                                        <label htmlFor="confirmPassword" className="text-gray-600 text-sm mb-2">Confirm Password *</label>
                                        <input type="password" id="confirmPassword" required value={applicant.confirmPassword} onChange={(e) => handleChange('confirmPassword', e.target.value)} className="w-full p-3 border rounded-md" />
                                    </div>

                                    {/* Gender */}
                                    <div className="relative flex flex-col mb-6">
                                        <label htmlFor="gender" className="text-gray-600 text-sm mb-2">Gender *</label>
                                        <select id="gender" value={applicant.gender} onChange={(e) => handleChange('gender', e.target.value)} className="w-full p-3 border rounded-md" required>
                                            <option value="">Select Gender *</option>
                                            <option value="MALE">Male</option>
                                            <option value="FEMALE">Female</option>
                                        </select>
                                    </div>

                                    {/* Dynamic Attributes */}
                                    {applicant.dynamicAttributes
                                        .filter(attribute => attribute.name !== 'Registration Class') // Filter out "Registration Class"
                                        .map((attribute, index) => (
                                            <div key={index} className="relative flex flex-col sm:w-full mb-6">
                                                <label htmlFor={`dynamicAttribute-${index}`} className="text-gray-600 text-sm mb-2">{attribute.name}</label>
                                                <input
                                                    type="text"
                                                    id={`dynamicAttribute-${index}`}
                                                    value={attribute.value}
                                                    onChange={(e) => handleNestedChange('dynamicAttributes', index, 'value', e.target.value)}
                                                    className="w-full p-3 border rounded-md"
                                                />
                                            </div>
                                        ))}
                                    {/* Registration Class */}
                                    <div className="relative flex flex-col mb-6">
                                        <label htmlFor="registrationClass" className="text-gray-600 text-sm mb-2">
                                            Registration Class *
                                        </label>
                                        <select
                                            id="registrationClass"
                                            value={applicant.dynamicAttributes.find(attr => attr.name === 'Registration Class')?.value || ''}
                                            onChange={(e) => {
                                                const selectedValue = e.target.value;
                                                const selectedProduct = validProducts.find(product => product.product.name === selectedValue); // Adjusted for nested product object

                                                if (selectedProduct) {
                                                    // Check if the status is 'ACTIVE'
                                                    if (selectedProduct.status !== 'ACTIVE') {
                                                        // If not active, show the pop-up and don't update the value
                                                        handleModalOpen();  // You would need to define this function to open the modal
                                                        return; // Prevent further execution
                                                    }

                                                    // Proceed to update value if status is 'ACTIVE'
                                                    handleNestedChange(
                                                        'dynamicAttributes',
                                                        applicant.dynamicAttributes.findIndex(attr => attr.name === 'Registration Class'),
                                                        'value',
                                                        selectedValue
                                                    );

                                                    // Store the full selected product data (not just the name) in localStorage
                                                    localStorage.setItem('selectedRegistrationClass', JSON.stringify(selectedProduct));
                                                }
                                            }}
                                            className="w-full p-3 border rounded-md"
                                            required
                                        >
                                            <option value="">Select Registration Class</option>
                                            {validProducts.length > 0 ? (
                                                validProducts.map((item, index) => {
                                                    const product = item.product; // Access the product object
                                                    if (product && product.status === 'ACTIVE') {
                                                        return (
                                                            <option key={index} value={product.name}>
                                                                {product.name}
                                                            </option>
                                                        );
                                                    }
                                                    return null; // Do not display the option if status is not 'ACTIVE'
                                                })
                                            ) : (
                                                <option disabled>Loading options...</option>
                                            )}
                                        </select>
                                    </div>


                                </div>
                            </section>

                            <section className="space-y-6 bg-gray-50 p-6 rounded-lg shadow-md mt-6">
                                <h2 className="text-lg font-semibold text-[#824296] text-center">Address Details</h2>
                                {applicant.addressList.map((address, index) => (
                                    <div key={index} className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                        {/* Street Name 1 */}
                                        <div className="relative flex flex-col mb-6">
                                            <label htmlFor={`streetName1-${index}`} className="text-gray-600 text-sm mb-2">Street Name 1 *</label>
                                            <input type="text" id={`streetName1-${index}`} value={address.streetName1} required onChange={(e) => handleNestedChange('addressList', index, 'streetName1', e.target.value)} className="w-full p-3 border rounded-md" />
                                        </div>

                                        {/* Street Name 2 */}
                                        <div className="relative flex flex-col mb-6">
                                            <label htmlFor={`streetName2-${index}`} className="text-gray-600 text-sm mb-2">Street Name 2</label>
                                            <input type="text" id={`streetName2-${index}`} value={address.streetName2} onChange={(e) => handleNestedChange('addressList', index, 'streetName2', e.target.value)} className="w-full p-3 border rounded-md" />
                                        </div>

                                        {/* City */}
                                        <div className="relative flex flex-col mb-6">
                                            <label htmlFor={`city-${index}`} className="text-gray-600 text-sm mb-2">City *</label>
                                            <input type="text" id={`city-${index}`} value={address.city} required onChange={(e) => handleNestedChange('addressList', index, 'city', e.target.value)} className="w-full p-3 border rounded-md" />
                                        </div>

                                        {/* State */}
                                        <div className="relative flex flex-col mb-6">
                                            <label htmlFor={`state-${index}`} className="text-gray-600 text-sm mb-2">State *</label>
                                            <input type="text" id={`state-${index}`} value={address.state} required onChange={(e) => handleNestedChange('addressList', index, 'state', e.target.value)} className="w-full p-3 border rounded-md" />
                                        </div>

                                        {/* Zipcode */}
                                        <div className="relative flex flex-col mb-6">
                                            <label htmlFor={`zipcode-${index}`} className="text-gray-600 text-sm mb-2">Zipcode *</label>
                                            <input type="text" id={`zipcode-${index}`} value={address.zipcode} required onChange={(e) => handleNestedChange('addressList', index, 'zipcode', e.target.value)} className="w-full p-3 border rounded-md" />
                                        </div>

                                        {/* Country */}
                                        <div class Name="relative flex flex-col mb-6">
                                            <label htmlFor={`country-${index}`} className="text-gray-600 text-sm mb-2">Country *</label>
                                            <input type="text" id={`country-${index}`} value={address.country} required onChange={(e) => handleNestedChange('addressList', index, 'country', e.target.value)} className="w-full p-3 border rounded-md" />
                                        </div>
                                    </div>
                                ))}
                            </section>

                            <section className="space-y-6 bg-gray-100 p-6 rounded-lg shadow-md mt-6">
                                <h2 className="text-lg font-semibold text-[#824296] text-center">Contact Person</h2>
                                <br />
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                    {/* Contact Person's First Name */}
                                    <div className="relative flex flex-col mb-6">
                                        <label htmlFor="contactFirstName" className="text-gray-600 text-sm mb-2">Contact Person's First Name *</label>
                                        <input type="text" id="contactFirstName" value={applicant.contactPerson.firstName} onChange={(e) => handleNestedChange('contactPerson', null, 'firstName', e.target.value)} className="w-full p-3 border rounded-md" required />
                                    </div>

                                    {/* Contact Person's Last Name */}
                                    <div className="relative flex flex-col mb-6">
                                        <label htmlFor="contactLastName" className="text-gray-600 text-sm mb-2">Contact Person's Last Name *</label>
                                        <input type="text" id="contactLastName" value={applicant.contactPerson.lastName} onChange={(e) => handleNestedChange('contactPerson', null, 'lastName', e.target.value)} className="w-full p-3 border rounded-md" required />
                                    </div>

                                    {/* Contact Person's Email */}
                                    <div className="relative flex flex-col mb-6">
                                        <label htmlFor="contactEmail" className="text-gray-600 text-sm mb-2">Contact Person's Email *</label>
                                        <input type="email" id="contactEmail" value={applicant.contactPerson.email} onChange={(e) => handleNestedChange('contactPerson', null, 'email', e.target.value)} className="w-full p-3 border rounded-md" required />
                                    </div>

                                    {/* Contact Person's Phone Number */}
                                    <div className="relative flex flex-col mb-6">
                                        <label htmlFor="contactPhoneNumber" className="text-gray-600 text-sm mb-2">Contact Person's Phone Number *</label>
                                        <input type="text" id="contactPhoneNumber" value={applicant.contactPerson.phoneNumber} onChange={(e) => handleNestedChange('contactPerson', null, 'phoneNumber', e.target.value)} className="w-full p-3 border rounded-md" required />
                                    </div>
                                </div>
                            </section>

                            <section className="space-y-6 bg-gray-100 p-6 rounded-lg shadow-md mt-6">
                                <h2 className="text-lg font-semibold text-[#824296] text-center">Education Details</h2>
                                <br />
                                {applicant.educationDetails.map((education, index) => (
                                    <div key={index} className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                        {/* School Name */}
                                        <div className="relative flex flex-col mb-6">
                                            <label htmlFor={`schoolName-${index}`} className="text-gray-600 text-sm mb-2">School Name *</label>
                                            <input type="text" id={`schoolName-${index}`} value={education.schoolName} required onChange={(e) => handleNestedChange('educationDetails', index, 'schoolName', e.target.value)} className="w-full p-3 border rounded-md" />
                                        </div>

                                        {/* Degree Select */}
                                        <div className="relative flex flex-col mb-6">
                                            <label htmlFor={`degree-${index}`} className="text-gray-600 text-sm mb-2">Board *</label>
                                            <select id={`degree-${index}`} value={education.degree} onChange={(e) => handleNestedChange('educationDetails', index, 'degree', e.target.value)} className="w-full p-3 border rounded-md" required>
                                                <option value="">Select Board</option>
                                                <option value="Metric">Metric</option>
                                                <option value="CBSE">CBSE</option>
                                                <option value="Alango Indian">Alango Indian</option>
                                            </select>
                                        </div>
                                    </div>
                                ))}
                            </section>

                            <section className="space-y-8 bg-gray-100 p-6 rounded-lg shadow-md mt-6">
                                <h2 className="text-lg font-semibold text-[#824296] text-center">Parent Details</h2>
                                <br />
                                {applicant.parentDetails.map((parent, index) => {
                                    const relationship = parent.dynamicAttributes.find(attr => attr.name === 'Relationship')?.value;
                                    const isFather = relationship === 'Father';
                                    const isMother = relationship === 'Mother';

                                    return (
                                        <div key={index} className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                                            {/* Father's or Mother's First Name */}
                                            <div className="relative flex flex-col mb-6">
                                                <label htmlFor={`firstName-${index}`} className="text-gray-600 text-sm mb-2">
                                                    {isFather ? "Father's First Name *" : isMother ? "Mother's First Name *" : "Parent's First Name *"}
                                                </label>
                                                <input
                                                    type="text"
                                                    id={`firstName-${index}`}
                                                    value={parent.firstName}
                                                    onChange={(e) =>
                                                        handleNestedChange('parentDetails', index, 'firstName', e.target.value)
                                                    }
                                                    className="w-full p-4 h-12 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                    required
                                                />
                                            </div>

                                            {/* Father's or Mother's Last Name */}
                                            <div className="relative flex flex-col mb-6">
                                                <label htmlFor={`lastName-${index}`} className="text-gray-600 text-sm mb-2">
                                                    {isFather ? "Father's Last Name *" : isMother ? "Mother's Last Name *" : "Parent's Last Name *"}
                                                </label>
                                                <input
                                                    type="text"
                                                    id={`lastName-${index}`}
                                                    value={parent.lastName}
                                                    onChange={(e) =>
                                                        handleNestedChange('parentDetails', index, 'lastName', e.target.value)
                                                    }
                                                    className="w-full p-4 h-12 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                    required
                                                />
                                            </div>

                                            {/* Father's or Mother's Email */}
                                            <div className="relative flex flex-col mb-6">
                                                <label htmlFor={`email-${index}`} className="text-gray-600 text-sm mb-2">
                                                    {isFather ? "Father's Email *" : isMother ? "Mother's Email *" : "Parent's Email *"}
                                                </label>
                                                <input
                                                    type="email"
                                                    id={`email-${index}`}
                                                    value={parent.email}
                                                    onChange={(e) =>
                                                        handleNestedChange('parentDetails', index, 'email', e.target.value)
                                                    }
                                                    className="w-full p-4 h-12 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                    required
                                                />
                                            </div>

                                            {/* Father's or Mother's Phone Number */}
                                            <div className="relative flex flex-col mb-6">
                                                <label htmlFor={`phoneNumber-${index}`} className="text-gray-600 text-sm mb-2">
                                                    {isFather ? "Father's Phone Number *" : isMother ? "Mother's Phone Number *" : "Parent's Phone Number *"}
                                                </label>
                                                <input
                                                    type="text"
                                                    id={`phoneNumber-${index}`}
                                                    value={parent.phoneNumber}
                                                    onChange={(e) =>
                                                        handleNestedChange('parentDetails', index, 'phoneNumber', e.target.value)
                                                    }
                                                    className="w-full p-4 h-12 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                    required
                                                />
                                            </div>

                                            {/* Father's or Mother's Occupation */}
                                            <div className="relative flex flex-col mb-6">
                                                <label htmlFor={`occupation-${index}`} className="text-gray-600 text-sm mb-2">
                                                    {isFather ? "Father's Occupation *" : isMother ? "Mother's Occupation *" : "Parent's Occupation *"}
                                                </label>
                                                <input
                                                    type="text"
                                                    id={`occupation-${index}`}
                                                    value={parent.occupation}
                                                    onChange={(e) =>
                                                        handleNestedChange('parentDetails', index, 'occupation', e.target.value)
                                                    }
                                                    className="w-full p-4 h-12 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                    required
                                                />
                                            </div>
                                            <div className="relative flex flex-col mb-6">
                                                <label htmlFor={`annualIncome-${index}`} className="text-gray-600 text-sm mb-2">
                                                    {isFather ? "Father's Annual Income *" : isMother ? "Mother's Annual Income *" : "Parent's Annual Income *"}
                                                </label>
                                                <input
                                                    type="number"
                                                    id={`annualIncome-${index}`}
                                                    value={parent.annualIncome}
                                                    onChange={(e) =>
                                                        handleNestedChange('parentDetails', index, 'annualIncome', e.target.value)
                                                    }
                                                    className="w-full p-4 h-12 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    );
                                })}
                            </section>

                            <div className="flex justify-center mt-6">
                                <button type="submit" className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700">
                                    Save & Next
                                </button>
                            </div>
                        </form>
                        <Snackbar
                            autoHideDuration={6000}
                            isOpen={openSnackbar}
                            message={snackbarMessage}
                            onClose={() => setOpenSnackbar(false)}
                            tone={snackbarSeverity}
                        />
                        <Modal open={openModal} onClose={handleModalClose}>
                            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                                <div className="modal-content bg-[#f9f9f9] p-6 rounded-md shadow-lg max-w-md mx-auto">
                                    <h2 className="text-lg font-semibold text-center mb-4">
                                        Online application for the selected class is currently disabled.
                                    </h2>
                                    <p className="text-center mb-4">
                                        Please contact us if you have any queries or submit an enquiry.
                                    </p>
                                    <Button onClick={handleModalClose} className="self-center">
                                        Close
                                    </Button>
                                </div>
                            </div>
                        </Modal>



                    </div>
                </div>
            </div> <br /></div>
    );
};

export default AdmissionForm;
